import { render, staticRenderFns } from "./personalwork.vue?vue&type=template&id=c022d570&"
import script from "./personalwork.vue?vue&type=script&lang=js&"
export * from "./personalwork.vue?vue&type=script&lang=js&"
import style0 from "./personalwork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports